<template>
  <div class="sidebar" :class="{ 'is-collapsed': !sidebarOpened }">
    <el-menu
      :default-active="$route.path"
      :collapse="!sidebarOpened"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <!-- 仪表盘 -->
      <el-menu-item index="/dashboard">
        <i class="el-icon-s-home"></i>
        <span slot="title">控制台</span>
      </el-menu-item>
      
      <!-- 委托管理 -->
      <el-menu-item index="/commission/index">
        <i class="el-icon-s-order"></i>
        <span slot="title">委托管理</span>
      </el-menu-item>
      
      <!-- 样品接收 -->
      <el-menu-item index="/samples/index">
        <i class="el-icon-s-management"></i>
        <span slot="title">样品接收</span>
      </el-menu-item>
      
      <!-- 检测报告 -->
      <el-menu-item index="/reports/index">
        <i class="el-icon-document"></i>
        <span slot="title">检测报告</span>
      </el-menu-item>
      
      <!-- 人员管理 -->
      <el-menu-item index="/users/index">
        <i class="el-icon-user"></i>
        <span slot="title">人员管理</span>
      </el-menu-item>
      
      <!-- 系统管理 -->
      <el-submenu index="/system">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item index="/system/log">日志管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SimpleSidebar',
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    sidebarOpened() {
      return this.sidebar && this.sidebar.opened
    }
  },
  mounted() {
    console.log('SimpleSidebar mounted, sidebar state:', this.sidebar)
  },
  watch: {
    sidebarOpened(val) {
      console.log('sidebarOpened changed to:', val)
    }
  }
}
</script>

<style scoped>
.sidebar {
  height: 100%;
  background-color: #304156;
  transition: width 0.3s;
  width: 210px;
  overflow: hidden;
}

.is-collapsed {
  width: 64px !important;
}
</style> 